import { TIPOS_DESTINO_BODEGA_PT } from "../../../../../../../../utility/constants";

// Conformidad de las existencias que pueden despacharse según el destino de la
// salida: reproceso solo recibe producto no conforme; reclasificación y cliente
// reciben ambos, por lo que no se envía filtro
export const tipoExistenciaSegunDestino = (tipoDestino) => {
    if (tipoDestino === TIPOS_DESTINO_BODEGA_PT.REPROCESO) {
        return "no_conforme";
    }

    return undefined;
};
